module.exports = __webpack_public_path__ + "static/media/valor2.541aadfb.png";